module.exports = __webpack_public_path__ + "img/search-test-no-result.cb240763.webp";